import { Container, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { Flex } from '../../../styledComponents';
import Card from '../../../components/layout/Card';
import { PieChart } from '@mui/x-charts/PieChart';
import PostsBarChart from '../../../components/PostsBarChart';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import { setAllDashboardCount, setAllDashboardPostsCount } from '../../../redux/slices/dashboard/dashboard';
import CountBarChart from '../../../components/CountBarChart';

const Dashboard = () => {

	const data = [
		{ id: 0, value: 10, label: 'series A' },
		{ id: 1, value: 15, label: 'series B' },
		{ id: 2, value: 20, label: 'series C' },
	];
	const dispatch = useDispatch();
	const { dashboardCount, dashboardPostsCount } = useSelector((state) => state?.dashboard);

	const [isLoading, setIsLoading] = useState(false);


	const getCount = async () => {
		setIsLoading(true)
		try {
			await Api.post(`${endPoints?.dashboard?.fetchCount}`, {}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllDashboardCount(response?.data?.data?.shareHolderCount),
					);
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};
	const getPostsCount = async () => {
		setIsLoading(true)
		try {
			await Api.post(`${endPoints?.dashboard?.fetchPostsCount}`, {}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllDashboardPostsCount(response?.data?.data?.totalPosts),
					);
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	useEffect(() => {
		getCount();
		getPostsCount();
	}, [])

	return (
		<Card margin='3rem 1.5rem' padding='5rem'>
			{/* <Flex ff='column' jc='center' ai='center'> */}
				{/* <Container maxWidth='xl'> */}
					<Grid container spacing={4}>

						<Grid xs={12} md={6} lg={8} p={5}>
						{dashboardPostsCount && <PostsBarChart xLables={dashboardPostsCount} />}
						</Grid>
						<Grid xs={12} md={6} lg={4} p={5}>
							{dashboardCount && <CountBarChart xLables={dashboardCount} />}
						</Grid>

					</Grid>

					{/* {roleCheck && roleCheck?.length > 0 ? ( */}

					{/* <Grid gtc='repeat(auto-fit, minmax(50rem, 1fr))' gtc768='1fr' margin='1rem 0'>
						<BarChart
							xAxis={[
								{
									id: 'barCategories',
									data: ['bar A', 'bar B', 'bar C'],
									scaleType: 'band',
								},
							]}
							series={[
								{
									data: [2, 5, 3],
								},
							]}
							width={500}
							height={300}
						/>
						<PieChart
							series={[
								{
									data,
									highlightScope: { faded: 'global', highlighted: 'item' },
									faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
								},
							]}
							height={300}
						/>

					</Grid> */}

					{/* // ) : (
				// 	''
				// )} */}
					{/* <EmployeeDetails /> */}
				{/* </Container> */}
			{/* </Flex> */}
		</Card>
	);
};

export default Dashboard;
